/* eslint-disable no-extend-native */
import { api, dynamic } from './api';
import CacheStorage from './CacheStorage';
import MeRepository from './MeRepository';
import { entities, NotificationModule } from '../Constants';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

class AuditRepository {
  constructor() {
    this.year = new Date().getFullYear();
    this.cacheStorage = new CacheStorage();
    this.years = Array.from(new Array(5), (val, index) => index + this.year);
  }

  updateCachedAudit(data) {
    const url = `${baseURL}/audit/${data.id}`;
    this.cacheStorage.updateCache(data, url);
  }

  updateCachedAuditPlan(data) {
    const url = `${baseURL}/audit/program/${data.id}`;
    this.cacheStorage.updateCache(data, url);
  }

  updateCachedAuditList = async (data, year) => {
    await this.clearOldYear(data);
    const url = `${baseURL}/audit/${year}/skip/0/take/10?year=${year}`;
    const items = await this.cacheStorage.getFromCache(url);

    if (items) {
      const element = items.find((el) => el.id === data.id);

      if (!element || element == null) {
        items.unshift(data);
      } else {
        items[items.indexOf(element)] = data;
      }
      await this.cacheStorage.updateCache(items, url);
    } else {
      const newItems = [];
      newItems.unshift(data);
      await this.cacheStorage.updateCache(newItems, url);
    }
  };

  clearOldYear = async (data) =>
    this.years.forEach(async (year) => {
      if (year !== data.referenceYear) {
        const url = `${baseURL}/audit/${year}/skip/0/take/10`;
        const items = await this.cacheStorage.getFromCache(url);

        if (items) {
          const index = items.findIndex((el) => el.id === data.id);
          items.splice(index, 1);
          await this.cacheStorage.updateCache(items, url);
        }
      }
    });

  updateCachedCarList = async (data, updateCAList = true) => {
    let url = `${baseURL}/audit/${data.idAudit}/answer/${data.idAnswer}/car/`;

    let items = (await this.cacheStorage.getFromCache(url)) || { auditCAR: [] };

    let element = items.auditCAR.find((el) => el.id === data.id);

    if (element == null) {
      items.auditCAR = items.auditCAR.concat([data]);
    } else {
      items.auditCAR[items.auditCAR.indexOf(element)] = data;
    }
    await this.cacheStorage.updateCache(items, url);

    url = `${baseURL}/audit/${data.idAudit}/car/`;
    items = (await this.cacheStorage.getFromCache(url)) || { auditCAR: [] };

    element = items.auditCAR.find((el) => el.id === data.id);

    if (element == null) {
      items.auditCAR = items.auditCAR.concat([data]);
    } else {
      items.auditCAR[items.auditCAR.indexOf(element)] = data;
    }
    await this.cacheStorage.updateCache(items, url);

    url = `${baseURL}/audit/${data.idAudit}`;
    const audit = await this.cacheStorage.getFromCache(url);
    if (audit) {
      const answer = audit.checkList.answers.find((el) => el.id === data.idAnswer);
      const car = answer.cars.find((c) => c.id === data.id);
      if (car == null) {
        answer.cars = answer.cars.concat([data]);
      } else {
        answer.cars[answer.cars.indexOf(car)] = data;
      }
      audit.checkList.answers[audit.checkList.answers.indexOf(answer)] = answer;
      url = `${baseURL}/audit/${data.idAudit}`;
      await this.cacheStorage.updateCache(audit, url);
    }

    if (updateCAList) {
      url = `${baseURL}/audit/${data.idAudit}/answer/${data.idAnswer}/car/${data.id}?page=1&pageSize=10`;
      if (!data.audit) {
        if (!data.result) {
          data.audit = {
            checkList: {
              idCompiler: audit.checkList.idCompiler,
              idApprover: audit.checkList.idApprover,
              idDivisionManager: audit.checkList.idDivisionManager,
            },
          };
          const carDetail = {
            result: data,
            resultCas: {
              currentPage: 1,
              itemList: [],
              pageCount: 0,
              pageSize: 10,
              rowCount: 0,
            },
          };
          data = carDetail;
        }
      }
      await this.cacheStorage.updateCache(data, url);
    }
  };

  updateCachedCaList = async (data, idAudit, idAnswer, toDelete = false) => {
    const url = `${baseURL}/audit/${idAudit}/answer/${idAnswer}/car/${data.idAuditCAR}?page=1&pageSize=10`;

    const cacheResult = await this.cacheStorage.getFromCache(url);
    if (cacheResult) {
      const element = cacheResult.result?.ca.find((el) => el.id === data.id);

      if (element == null) {
        cacheResult.result.ca = cacheResult.result?.ca.concat([data]);
      } else {
        if (toDelete) cacheResult.result.ca = cacheResult.result?.ca.filter((x) => x.id != data.id);
        else cacheResult.result.ca[cacheResult.result?.ca.indexOf(element)] = data;
      }
      await this.cacheStorage.updateCache(cacheResult, url);
    }

    if (cacheResult) this.updateCachedCarList(cacheResult.result, false);
  };

  updateCachedCaDetails = async (data) => {
    const url = `${baseURL}/audit/${data.auditCAR.idAudit}/answer/${data.auditCAR.idAnswer}/car/${data.idAuditCAR}/ca/${data.id}/detail`;
    await this.cacheStorage.updateCache(data, url);
  };

  updateCachedAuditCount = async (year) => {
    let totalAudits = await this.getCachedAuditCount(year);
    totalAudits += 1;
    this.cacheStorage.updateCache(totalAudits, `${baseURL}/audit/${year}`);
  };
  updateCachedAuditFilter = async (filter) => {
    this.cacheStorage.updateCache(filter, `${baseURL}/listofaudit/filter`);
  };

  getCachedAuditsFilter = async () => {
    const url = `${baseURL}/listofaudit/filter`;
    const filter = await this.cacheStorage.getFromCache(url);
    return filter || [];
  };
  getCachedAudits = async (year) => {
    const url = `${baseURL}/audit/${year}`;
    const audit = await this.cacheStorage.getFromCache(url);
    return audit || [];
  };

  getCachedAuditCount = async (year) => {
    const url = `${baseURL}/audit/${year}`;
    const count = await this.cacheStorage.getFromCache(url);
    return count || 0;
  };

  getCachedTypes = async () => {
    const url = `${baseURL}/audit/types`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedScopes = async () => {
    const url = `${baseURL}/audit/scopes`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedStatuses = async () => {
    const url = `${baseURL}/audit/status`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedTargets = async () => {
    const url = `${baseURL}/audit/target`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedWorkSites = async () => {
    const url = `${baseURL}/me/audit/worksites`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedEmployees = async () => {
    const url = `${baseURL}/employees/all`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedSection = async () => {
    const url = `${baseURL}/audit/sections`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedAuditors = async (idDivision) => {
    const url = `${baseURL}/audit/divisions/${idDivision}/auditors`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedNCClassificationTypes = async () => {
    const url = `${baseURL}/admin/auditncclassificationtype?page=0&parent=all`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getCachedLevels = async () => {
    const url = `${baseURL}/admin/auditcarlevel?page=0&parent=all`;
    const items = await this.cacheStorage.getFromCache(url);
    return items || undefined;
  };

  getAudit = async (id) => (await api.getAll(`/audit/${id}`)).data;

  getAuditCount = async (year, filter) => (await api.getWithParam(`/audit/${year}`, filter)).data;

  getDeletedAuditCount = async () => (await api.getWithParam('/audit/deleted')).data;

  getAuditYearAsync = async () => (await api.getWithParam('/audit/years')).data;

  getAuditCountByMonth = async (year, filter) =>
    (await api.getWithParam(`/audit/${year}/months`, filter)).data;

  getAudits = async (year, skip, take, filter) =>
    (await api.getWithParam(`/audit/${year}/skip/${skip}/take/${take}`, filter)).data;

  getDeletedAudits = async (skip, take) =>
    (await api.getWithParam(`/audit/deleted/skip/${skip}/take/${take}`)).data;

  getAuditors = async (email) =>
    (await api.getAll(`/users/userworksite/${NotificationModule.ModuleAudit}`)).data;

  //B1_Audit_Module_Optimization
  getCachedAuditor = async () => {
      const url = `${baseURL}/users/userworksite/${NotificationModule.ModuleAudit}`;
      const items = await this.cacheStorage.getFromCache(url);
      return items || undefined;
    };

  getCachedReasonForSampling = async () => {
      const url = `${baseURL}/audit/reasonsforsampling`;
      const items = await this.cacheStorage.getFromCache(url);
      return items || undefined;
    };

  getCachedCountries= async () => {
      const url = `${baseURL}/audit/countries`;
      const items = await this.cacheStorage.getFromCache(url);
      return items || undefined;
    };

  getCachedProjects= async () => {
      const url = `${baseURL}/project`;
      const items = await this.cacheStorage.getFromCache(url);
      return items || undefined;
    };

  getCachedDivisions = async () => {
      const url = `${baseURL}/me/divisions`;
      const items = await this.cacheStorage.getFromCache(url);
      return items || undefined;
    };

  getCachedCompanies = async () => {
      const url = `${baseURL}/company`;
      const items = await this.cacheStorage.getFromCache(url);
      return items || undefined;
    };
  //End

  getTypes = async (section) => {
    const types = /* (await this.getCachedTypes()) || */ (await api.getAll('/audit/types')).data;
    if (section) return types.filter((w) => w.idAuditSection === section);
    return types;
  };

  getScopes = async (section) => {
    const scopes = /* (await this.getCachedScopes()) || */ (await api.getAll('/audit/scopes')).data;
    if (section) return scopes.filter((w) => w.idAuditSection === section);
    return scopes;
  };

  getProcesses = async () => {
    const process = (await api.getAll('/audit/processes')).data;
    return process;
  };

  getCountries = async () => {
    const country = (await api.getAll('/audit/countries')).data;
    return country;
  };

  getFunctions = async () => {
    const functions = (await api.getAll('/audit/functions')).data;
    return functions;
  };

  getSubcontractors = async () => {
    const functions = (await api.getAll('/audit/subcontractors')).data;
    return functions;
  };

  getPurchaseOrders = async () => {  //RITM0646764
    const functions = (await api.getAll('/audit/getpurchaseorders')).data;
    return functions;
  }

  getStatuses = async () =>
    /*  (await this.getCachedStatuses()) ||  */ (await api.getAll('/audit/status')).data;

  getTargets = async () =>
    /*   (await this.getCachedTargets()) || */ (await api.getAll('/audit/target')).data;

  getSections = async () =>
    /* (await this.getCachedSection()) ||  */ (await api.getAll('/audit/sections')).data;

  getWorkSites = async (division) => {
    const worksites = /*  (await this.getCachedWorkSites()) ||  */ (
      await api.getAll('/me/audit/worksites')
    ).data;
    if (division) return worksites.filter((w) => w.idDivision === division);
    return worksites;
  };

  getNCClassificationTypes = async () =>
    /*  (await this.getCachedNCClassificationTypes()) || */
    (await dynamic.getAll('auditncclassificationtype', { params: { page: 0, parent: 'all' } }))
      .data;

  getLevels = async () =>
    (await dynamic.getAll('auditcarlevel', { params: { page: 0, parent: 'all' } })).data;

  getDivisionAuditors = async (idDivision) =>
    idDivision
      ? (await this.getCachedAuditors(idDivision)) ||
        (await api.getAll(`/audit/divisions/${idDivision}/auditors`)).data
      : [];

  getEmployees = async () =>
    (await this.getCachedEmployees()) || (await api.getAll('/employees/all')).data;

  fetchDivisionsAuditors = async () => {
    const divisions = await MeRepository.getDivisions();
    divisions.forEach(async (element) => {
      await api.getAll(`/audit/divisions/${element.id}/auditors`);
    });
  };

  getReasonForSampling = async () => {
    const reasons = (await api.getAll('/audit/reasonsforsampling')).data;
    return reasons;
  };

  getProgramDistributionList = async (idDivision) =>
    (await api.getAll(`/audit/distributionlist/program/${idDivision}`)).data;

  fetchAudit = async () => {
    this.years.forEach(async (year) => {
      await api.getAll(`/audit/${year}/skip/0/take/10`);
    });
    //await this.fetchDivisionsAuditors();
    await api.getAll(`/users/userworksite/${NotificationModule.ModuleAudit}`);
    await api.getAll('/audit/sections');
    await api.getAll('/audit/types');
    await api.getAll('/audit/scopes');
    await api.getAll('/audit/status');
    await api.getAll('/audit/target');
    await dynamic.getAll('auditncclassificationtype', { params: { page: 0, parent: 'all' } });
    await dynamic.getAll('auditcarlevel', { params: { page: 0, parent: 'all' } });
    await api.getAll('/me/audit/worksites');
    await api.getAll('/audit/reasonsforsampling');
    await api.getAll('/audit/subcontractors');
    await api.getAll('/audit/getpurchaseorders');
    await api.getAll('/audit/functions');
    await api.getAll('/audit/processes');
  };
}

export default AuditRepository;
